import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tags: [],
  search: "",
  author: "",
  page: 1,
  limit: 8,
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    tagSelected: (state, action) => {
      state.tags.push(action.payload);
      state.page = 1;
    },
    tagRemoved: (state, action) => {
      const indexToRemove = state.tags.indexOf(action.payload);
      if (indexToRemove !== -1) {
        state.tags.splice(indexToRemove, 1);
        state.page = 1;
      }
    },
    searched: (state, action) => {
      state.search = action.payload;
      state.page = 1;
    },
    authorSelected: (state, action) => {
      state.author = action.payload;
      state.tags = [];
      state.search = "";
      state.page = 1;
    },
    resetFilter: (state) => {
      state.tags = [];
      state.search = "";
      state.author = "";
      state.page = 1;
    },
    pageSelected: (state, action) => {
      state.page = action.payload;
    },
    limitSelected: (state, action) => {
      state.limit = action.payload;
      state.page = 1;
    },
  },
});

export default filterSlice.reducer;
export const { authorSelected, tagSelected, tagRemoved, searched, resetFilter, pageSelected, limitSelected } =
  filterSlice.actions;
